import { validateListingFormInventorySection } from './infrastructureListingInventoryAvailabilityUi';

const str = (v) => (v == null ? '' : String(v)).trim();
const num = (v) => {
  const n = parseFloat(String(v).replace(/,/g, ''), 10);
  return Number.isFinite(n) ? n : NaN;
};

/**
 * @param {object} f - form state
 * @param {object} ctx
 * @param {number} ctx.subSubOptionsCount - master sub-sub options for current sub-category
 * @returns {{ valid: boolean, errors: string[] }}
 */
export function validateInfrastructureListingForPublish(f, ctx = {}) {
  const errors = [];
  const subSubCount = ctx.subSubOptionsCount != null ? Number(ctx.subSubOptionsCount) : 0;
  const listing = f?.listingType === 'property' ? 'property' : 'machinery';

  if (!str(f?.listingTitle)) {
    errors.push('Listing title is required.');
  }
  if (!str(f?.assetCategory)) {
    errors.push('Asset category is required.');
  }
  if (!str(f?.subCategory)) {
    errors.push('Sub-category is required.');
  }
  if (listing === 'machinery' && f?.subCategory && subSubCount > 0) {
    if (!str(f?.subSubCategory)) {
      errors.push('Sub-sub-category is required for this sub-category.');
    }
  }
  if (f?.assetSize === 'small' || f?.assetSize === 'micro') {
    const q = num(f?.quantityAvailable);
    if (!str(f?.quantityAvailable) || !Number.isFinite(q) || q < 1) {
      errors.push('Quantity available must be a number of at least 1 when size is Micro or Small.');
    }
  }

  if (!str(f?.countryId) || !str(f?.stateId) || !str(f?.cityId)) {
    errors.push('Country, state/province, and city are required.');
  }
  if (!str(f?.fullAddress)) {
    errors.push('Full address & landmarks are required.');
  }

  if (listing === 'property') {
    if (!str(f?.propertyType)) {
      errors.push('Property type is required.');
    }
    const carpet = num(f?.carpetArea);
    if (!str(f?.carpetArea) || !Number.isFinite(carpet) || carpet <= 0) {
      errors.push('Carpet area (sq ft) must be a positive number.');
    }
  }

  if (listing === 'machinery') {
    [
      ['equipmentBrand', 'Brand'],
      ['equipmentModel', 'Model'],
      ['equipmentMake', 'Make'],
      ['serialNumber', 'Serial number'],
      ['manufactureYear', 'Year'],
    ].forEach(([key, label]) => {
      if (!str(f?.[key])) {
        errors.push(`${label} is required.`);
      }
    });
    if (!str(f?.manufactureYear) || !Number.isFinite(num(f?.manufactureYear))) {
      /* already caught */
    } else {
      const y = parseInt(f.manufactureYear, 10);
      if (y < 1980 || y > new Date().getFullYear() + 1) {
        errors.push('Please enter a valid year.');
      }
    }
    if (!str(f?.equipmentCondition)) {
      errors.push('Condition is required.');
    }
    if (!str(f?.operationalStatus)) {
      errors.push('Status is required.');
    }
    if (!str(f?.usageHours) || !Number.isFinite(num(f?.usageHours)) || num(f?.usageHours) < 0) {
      errors.push('Usage hours is required and must be a non-negative number.');
    }
    if (!str(f?.maxCapacity) || !Number.isFinite(num(f?.maxCapacity)) || num(f?.maxCapacity) <= 0) {
      errors.push('Max capacity is required and must be a positive number.');
    }
    if (!str(f?.weightUnit)) {
      errors.push('Weight unit is required.');
    }
    if (!str(f?.installationLocation)) {
      errors.push('Current installation location is required.');
    }
    if (f?.relocationPossible) {
      const rc = str(f?.relocationCost) ? num(f.relocationCost) : NaN;
      if (str(f?.relocationCost) && !Number.isFinite(rc)) {
        errors.push('Relocation cost must be a valid number if provided.');
      }
    }
    if (f?.operatorIncluded) {
      const oc = str(f?.operatorAddOnCost) ? num(f.operatorAddOnCost) : 0;
      if (str(f?.operatorAddOnCost) && !Number.isFinite(oc)) {
        errors.push('Operator add-on must be a valid number if provided.');
      }
    }
    if (!str(f?.insuranceStatus)) {
      errors.push('Insurance status is required.');
    }
    if (!str(f?.transportResponsibility)) {
      errors.push('Transport responsibility is required.');
    }
    if (!str(f?.transportCost) || !Number.isFinite(num(f.transportCost)) || num(f.transportCost) < 0) {
      errors.push('Transport cost (₹) is required and must be a non-negative number.');
    }
  }

  if (!str(f?.rentPerMonth) || !Number.isFinite(num(f.rentPerMonth)) || num(f.rentPerMonth) <= 0) {
    errors.push('Rent per month (₹) is required and must be a positive number.');
  }
  if (!str(f?.availableFrom)) {
    errors.push('Available from is required.');
  }
  if (!str(f?.description)) {
    errors.push('Detailed description is required.');
  }
  const imgs = f?.images;
  const hasListingImage =
    Array.isArray(imgs) &&
    imgs.some((x) => {
      if (x instanceof File) return true;
      if (typeof x === 'string' && str(x)) return true;
      if (x && typeof x === 'object' && str(x.accessPath)) return true;
      return false;
    });
  if (!hasListingImage) {
    errors.push('At least one image/photo is required (upload in the Media step).');
  }

  errors.push(...validateListingFormInventorySection(f));

  return { valid: errors.length === 0, errors };
}
